
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-8d6801b0!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ConfigAuthority.vue")
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-8d6801b0!../../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./ConfigAuthority.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ConfigAuthority.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-8d6801b0!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ConfigAuthority.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/user/ConfigAuthority.vue
// module id = 1018
// module chunks = 2